import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ListDivider } from '@fuww/library/src/List';
import {
  CourseList as List, CourseListItem, LogoContainer,
} from '@fuww/library/src/Layouts/CoursesPage';
import Image from '../Image';
import LinkAndAnchor from '../LinkAndAnchor';
import LoadMore from '../LoadMore';
import loadMore from '../../lib/queries/loadMore';

const CourseLogo = ({
  logoUrls, alt,
}) => (
  <LogoContainer>
    <Image
      placeholder={logoUrls[0]}
      src={logoUrls[1]}
      alt={alt}
      width="102px"
      height="auto"
      objectFit="cover"
      sizes="102px"
      srcSet={`${logoUrls[1]
      } 102w, ${logoUrls[2]
      } 204w, ${logoUrls[3]
      } 306w`}
      disableRoundedCorners
    />
  </LogoContainer>
);

CourseLogo.propTypes = {
  alt: PropTypes.string.isRequired,
  logoUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const CourseList = ({
  data,
  fetchMore,
  variables,
  primaryField,
  connectionField,
  loading,
}) => {
  const {
    edges,
    pageInfo: { hasNextPage = false } = {},
  } = primaryField
    ? data[primaryField][connectionField]
    : data[connectionField];

  return (
    <>
      <List className="fu-mdc-list">
        {edges.map(({ node }) => {
          const {
            title,
            id,
            introduction,
            companyName,
            city,
            slug,
            logoUrls,
          } = node;
          return (
            <Fragment key={id}>
              <li>
                <LinkAndAnchor
                  route="course"
                  params={{ id, slug }}
                  passHref
                >
                  <CourseListItem
                    logo={logoUrls[0]
                      && <CourseLogo logoUrls={logoUrls} alt={title} />}
                    title={title}
                    courseInfo={`${companyName}, ${city}`}
                    introduction={introduction}
                  />
                </LinkAndAnchor>
              </li>
              <ListDivider className="fu-mdc-list-divider" />
            </Fragment>
          );
        })}
      </List>
      <LoadMore
        loading={loading}
        hasNextPage={hasNextPage}
        fetchMore={
          () => loadMore({
            variables,
          })(data, connectionField, fetchMore, primaryField)
        }
      />
    </>
  );
};

CourseList.propTypes = {
  data: PropTypes.shape({}),
  fetchMore: PropTypes.func,
  variables: PropTypes.shape({}),
  primaryField: PropTypes.string,
  connectionField: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};

CourseList.defaultProps = {
  variables: null,
  data: {},
  fetchMore: undefined,
  primaryField: null,
};

export default CourseList;
